<template>
  <div id="home">
    <v-container pt-0 fluid>
      <v-row>
        <v-col cols="12" sm="6" md="4" lg="3">
          <v-card v-if="!loading">
            <v-card-title>
              Today
            </v-card-title>

            <v-list-item>
              <v-list-item-title>Bets Accepted</v-list-item-title>

              <v-list-item-title class="text-right">
                {{ bets.today.accepted }}
              </v-list-item-title>
            </v-list-item>

            <v-list-item>
              <v-list-item-title>Bets Rejected</v-list-item-title>

              <v-list-item-title class="text-right">
                {{ bets.today.rejected }}
              </v-list-item-title>
            </v-list-item>

            <v-list-item>
              <v-list-item-title>EV</v-list-item-title>

              <v-list-item-title class="text-right">
                <span
                  :class="{
                    profit: bets.today.ev >= 0,
                    loss: bets.today.ev < 0
                  }"
                >
                  {{ currency(bets.today.ev) }}
                </span>
              </v-list-item-title>
            </v-list-item>

            <v-list-item>
              <v-list-item-title>Profit</v-list-item-title>

              <v-list-item-title class="text-right">
                <span
                  :class="{
                    profit: bets.today.profit >= 0,
                    loss: bets.today.profit < 0
                  }"
                >
                  {{ currency(bets.today.profit) }}
                </span>
              </v-list-item-title>
            </v-list-item>
          </v-card>
          <v-card v-else>
            <v-skeleton-loader
              class="mb-4"
              type="card-heading"
            ></v-skeleton-loader>
            <v-skeleton-loader type="list-item"></v-skeleton-loader>
            <v-skeleton-loader type="list-item"></v-skeleton-loader>
            <v-skeleton-loader type="list-item"></v-skeleton-loader>
            <v-skeleton-loader type="list-item"></v-skeleton-loader>
          </v-card>
        </v-col>
        <v-col cols="12" sm="6" md="4" lg="3">
          <v-card v-if="!loading">
            <v-card-title>
              Lifetime
            </v-card-title>

            <v-list-item>
              <v-list-item-title>Bets Accepted</v-list-item-title>

              <v-list-item-title class="text-right">
                {{ bets.lifetime.accepted }}
              </v-list-item-title>
            </v-list-item>

            <v-list-item>
              <v-list-item-title>Bets Rejected</v-list-item-title>

              <v-list-item-title class="text-right">
                {{ bets.lifetime.rejected }}
              </v-list-item-title>
            </v-list-item>

            <v-list-item>
              <v-list-item-title>EV</v-list-item-title>

              <v-list-item-title class="text-right">
                <span
                  :class="{
                    profit: bets.lifetime.ev >= 0,
                    loss: bets.lifetime.ev < 0
                  }"
                >
                  {{ currency(bets.lifetime.ev) }}
                </span>
              </v-list-item-title>
            </v-list-item>

            <v-list-item>
              <v-list-item-title>Profit</v-list-item-title>

              <v-list-item-title class="text-right">
                <span
                  :class="{
                    profit: bets.lifetime.profit >= 0,
                    loss: bets.lifetime.profit < 0
                  }"
                >
                  {{ currency(bets.lifetime.profit) }}
                </span>
              </v-list-item-title>
            </v-list-item>
          </v-card>
          <v-card v-else>
            <v-skeleton-loader
              class="mb-4"
              type="card-heading"
            ></v-skeleton-loader>
            <v-skeleton-loader type="list-item"></v-skeleton-loader>
            <v-skeleton-loader type="list-item"></v-skeleton-loader>
            <v-skeleton-loader type="list-item"></v-skeleton-loader>
            <v-skeleton-loader type="list-item"></v-skeleton-loader>
          </v-card>
        </v-col>
        <v-col cols="12" sm="12" :md="cols('md')" :lg="cols('lg')">
          <v-card v-if="!loading">
            <v-card-title>
              Bots
              <v-spacer />
              <v-btn text :loading="statusLoading" @click="refreshOnlineStatus">
                <v-icon>mdi-refresh</v-icon>
              </v-btn>
              <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon v-bind="attrs" v-on="on">
                    mdi-dots-horizontal
                  </v-icon>
                </template>
                <v-list>
                  <v-list-item
                    v-for="a in botActions"
                    :key="a.name"
                    @click="a.click()"
                  >
                    <v-list-item-icon>
                      <v-icon :color="a.color">{{ a.icon }}</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>{{ a.name }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-card-title>
            <v-container pt-0 fluid>
              <v-row>
                <v-col
                  class="acc-col"
                  v-for="(grp, index) in groups"
                  v-bind:key="index"
                >
                  <v-card
                    v-for="bot in grp"
                    :key="bot.name"
                    class="bot"
                    :style="{
                      'border-color': botActiveColor(bot.name)
                    }"
                    flat
                  >
                    <v-list-item
                      :disabled="!bot.active"
                      :class="{
                        'bf-disconnected': isBetfairDisconnected(bot.name)
                      }"
                    >
                      <v-skeleton-loader
                        type="list-item-avatar"
                        v-if="statusLoading"
                      >
                      </v-skeleton-loader>
                      <v-list-item-icon v-if="!statusLoading" class="mr-4">
                        <v-icon v-if="botOnline(bot.name)" color="green">
                          mdi-check-circle
                        </v-icon>
                        <v-icon v-else :disabled="!bot.active">
                          mdi-close-circle
                        </v-icon>
                      </v-list-item-icon>

                      <v-list-item-title class="bot-name">
                        {{ bot.name }}
                      </v-list-item-title>
                      <v-list-item-subtitle v-if="botStatus[bot.name]">
                        <span class="item-right">
                          {{ botStatus[bot.name].ip_address }}
                        </span>
                      </v-list-item-subtitle>

                      <v-list-item-icon v-if="!statusLoading">
                        <v-menu offset-y>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon v-bind="attrs" v-on="on">
                              mdi-dots-horizontal
                            </v-icon>
                          </template>
                          <v-list>
                            <v-list-item
                              v-for="a in bookieActions.filter(a =>
                                a.show(bot)
                              )"
                              :key="a.name"
                              @click="a.click(bot)"
                            >
                              <v-list-item-icon>
                                <v-icon :color="a.color">{{ a.icon }}</v-icon>
                              </v-list-item-icon>
                              <v-list-item-content>
                                <v-list-item-title>{{
                                  a.name
                                }}</v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>
                          </v-list>
                        </v-menu>
                      </v-list-item-icon>
                    </v-list-item>
                  </v-card>
                </v-col>
              </v-row>
            </v-container>
          </v-card>
          <v-card v-else>
            <v-skeleton-loader
              class="mb-4"
              type="card-heading"
            ></v-skeleton-loader>
            <v-skeleton-loader type="list-item-avatar"></v-skeleton-loader>
            <v-skeleton-loader type="list-item-avatar"></v-skeleton-loader>
          </v-card>
        </v-col>

        <accounts-table
          :accounts="accounts"
          :loading="loading"
        ></accounts-table>
      </v-row>
    </v-container>
    <restart-bookie-dialog
      :bot="selectedBot"
      :dialog="dialogs.restartBookie"
      :close="closeRestartBookieDialog"
      :confirm="restartBookie"
    />
  </div>
</template>

<script>
import RestartBookieDialog from "../components/RestartBookieDialog";
import AccountsTable from "../components/AccountsTable";

import { get, onlineStatus } from "../lib/summary";
import {
  ping,
  restartBookie,
  checkBetResults,
  refreshUpcomingRaces
} from "../lib/commands";
import { send } from "../lib/remote";
import { currency, botColor } from "../lib/formatting";

export default {
  name: "Home",
  components: {
    RestartBookieDialog,
    AccountsTable
  },
  data() {
    return {
      loading: true,
      statusLoading: true,
      selectedBot: null,
      dialogs: {
        restartBookie: false
      },
      bets: {
        lifetime: {
          accepted: 0,
          rejected: 0,
          ev: 0,
          profit: 0
        },
        today: {
          accepted: 0,
          rejected: 0,
          ev: 0,
          profit: 0
        }
      },
      bots: [],
      accounts: [],
      botStatus: {},
      botActions: [
        {
          icon: "mdi-alert-octagon-outline",
          name: "Stop All",
          color: "red",
          click: () => this.stopAllBots()
        },
        {
          icon: "mdi-download",
          name: "Update & Restart All",
          color: "orange",
          click: () => this.updateRestartAllBots()
        }
      ],
      bookieActions: [
        {
          show: () => true,
          icon: "mdi-help-network",
          name: "Ping",
          color: "blue",
          click: bot => this.pingBot(bot.name)
        },
        {
          show: bot => this.botOnline(bot.name),
          icon: "mdi-refresh",
          name: "Restart",
          color: "green",
          click: bot => this.restartBot(bot.name)
        },
        {
          show: bot => !this.botOnline(bot.name),
          icon: "mdi-monitor",
          name: "Start",
          color: "green",
          click: bot => this.startBot(bot.name)
        },
        {
          show: () => true,
          icon: "mdi-alert-octagon-outline",
          name: "Stop",
          color: "red",
          click: bot => this.stopBot(bot.name)
        },
        {
          show: () => true,
          icon: "mdi-download",
          name: "Update and Restart",
          color: "orange",
          click: bot => this.updateAndRestartBot(bot.name)
        },
        {
          show: () => true,
          icon: "mdi-skull",
          name: "Force Stop",
          color: "black",
          click: bot => this.killBot(bot.name)
        },
        {
          show: bot => this.botOnline(bot.name),
          icon: "mdi-ticket",
          name: "Check Results",
          color: "purple",
          click: bot => this.checkResults(bot.name)
        },
        {
          show: bot => this.botOnline(bot.name),
          icon: "mdi-horseshoe",
          name: "Refresh Races",
          color: "brown",
          click: bot => this.refreshRaces(bot.name)
        }
      ]
    };
  },
  mounted() {
    this.refresh();
  },
  computed: {
    groups() {
      const bots = [...this.sortedBots()];

      const groupSize = 4;
      const groups = [];
      for (let i = 0; i <= groupSize; i++) {
        const grp = bots.slice(i * groupSize, i * groupSize + groupSize);
        if (grp.length) groups.push(grp);
      }

      return groups;
    }
  },
  methods: {
    sortedBots() {
      const b = [...this.bots];
      const active = b.filter(b => b.active);
      active.sort((x, y) => {
        const xOnline = this.botOnline(x.name) ? -1 : 1;
        const yOnline = this.botOnline(y.name) ? -1 : 1;

        if (xOnline < yOnline) return -1;
        if (xOnline > yOnline) return 1;

        if (x.name < y.name) return -1;
        if (x.name > y.name) return 1;
        return 0;
      });
      return active;
    },
    isBetfairDisconnected(bot) {
      return this.botOnline(bot) && this.betfairStatus(bot) !== "CONNECTED";
    },
    betfairStatus(bot) {
      return this.$store.getters.betfairStatus(bot);
    },
    async refresh() {
      this.loading = true;
      try {
        const summary = await get();
        this.bets = summary.bets;
        this.accounts = summary.accounts.map(a => {
          if (a.bookie === "sportsbetting") {
            a.bookie = "boombet";
          }
          return a;
        });
        this.bots = summary.bots.map(b => ({
          ...b,
          expand: false
        }));
      } catch (err) {
        this.showError(`Unable to read summary - ${err}`);
      } finally {
        this.loading = false;
      }

      this.refreshOnlineStatus();
    },
    async refreshOnlineStatus() {
      this.statusLoading = true;
      if (this.bots.length) {
        try {
          this.botStatus = {};
          const statuses = await onlineStatus();
          for (const botStatus of statuses) {
            this.botStatus[botStatus.name] = botStatus;
          }
        } catch (err) {
          this.showError(`Unable to read online status - ${err}`);
        } finally {
          this.statusLoading = false;
          console.log("status loaded");
        }
      }
    },
    botOnline(bot) {
      const online = this.botStatus[bot] && this.botStatus[bot].online;
      return !!online;
    },
    botActiveColor(bot) {
      return botColor(bot);
    },
    currency(amount) {
      return currency(amount);
    },
    async stopAllBots() {
      const onlineBots = this.bots.filter(bot => this.botOnline(bot.name));
      return Promise.all(onlineBots.map(bot => this.stopBot(bot.name)));
    },
    async updateRestartAllBots() {
      const onlineBots = this.bots.filter(bot => this.botOnline(bot.name));
      return Promise.all(
        onlineBots.map(bot => this.updateAndRestartBot(bot.name))
      );
    },
    async pingBot(bot) {
      try {
        const resp = await ping(bot);
        const online = resp && !resp.error;
        if (online) {
          this.showSuccess(`${bot} responded '${resp.message}'`);
        } else {
          this.showError(`${bot} is offline`);
        }

        const b = this.bots.find(b => b.name === bot);
        b.online = online;
      } catch (err) {
        this.showError(err);
      }
    },
    async stopBot(bot) {
      try {
        const resp = await send(bot, "stop");
        if (resp.successful) {
          this.showSuccess(`${bot} successfully stopped`);
          this.botStatus[bot].online = false;
        } else {
          this.showError(resp.message);
        }
      } catch (err) {
        this.showError(err);
      }
    },
    async killBot(bot) {
      try {
        const resp = await send(bot, "kill_slippy");
        if (resp.successful) {
          this.showSuccess(`${bot} successfully stopped`);
          this.botStatus[bot].online = false;
        } else {
          this.showError(resp.message);
        }
      } catch (err) {
        this.showError(err);
      }
    },
    async updateAndRestartBot(bot) {
      try {
        const resp = await send(bot, "update_and_restart");
        if (resp.successful) {
          this.showSuccess(`${bot} successfully stopped`);
          this.botStatus[bot].online = false;
        } else {
          this.showError(resp.message);
        }
      } catch (err) {
        this.showError(err);
      }
    },
    async restartBot(bot) {
      try {
        const resp = await send(bot, "start");
        if (resp.successful) {
          this.showSuccess(`${bot} successfully restarted`);
        } else {
          this.showError(resp.message);
        }
      } catch (err) {
        this.showError(err);
      }
    },
    async startBot(bot) {
      try {
        const resp = await send(bot, "start");
        if (resp.successful) {
          this.showSuccess(`${bot} successfully started`);
          this.botStatus[bot].online = true;
        } else {
          this.showError(resp.message);
        }
      } catch (err) {
        this.showError(err);
      }
    },
    async restartBookie(bot, bookie) {
      this.selectedBot = null;
      this.dialogs.restartBookie = false;

      try {
        const resp = await restartBookie(bot, bookie);
        if (resp.successful) {
          this.showSuccess(`${bookie} successfully restarted`);
        } else {
          this.showError(resp.message);
        }
      } catch (err) {
        this.showError(err);
      }
    },
    async checkResults(bot) {
      try {
        const resp = await checkBetResults(bot);
        if (resp.successful) {
          this.showSuccess(`${bot} result check successfully triggered`);
        } else {
          this.showError(resp.message);
        }
      } catch (err) {
        this.showError(err);
      }
    },
    async refreshRaces(bot) {
      try {
        const resp = await refreshUpcomingRaces(bot);
        if (resp.successful) {
          this.showSuccess(
            `${bot} refresh upcoming races successfully triggered`
          );
        } else {
          this.showError(resp.message);
        }
      } catch (err) {
        this.showError(err);
      }
    },
    showRestartBookieDialog(bot) {
      this.selectedBot = bot;
      this.dialogs.restartBookie = true;
    },
    closeRestartBookieDialog() {
      this.selectedBot = null;
      this.dialogs.restartBookie = false;
    },
    cols(size) {
      if (size === "md") {
        return Math.min(12, 4 * this.groups.length);
      } else if (size === "lg") {
        return Math.min(12, 3 * this.groups.length);
      } else {
        return 12;
      }
    }
  }
};
</script>

<style lang="scss">
.item-right {
  float: right;
  margin-right: 10px;
}

.loss {
  color: red;
}

.profit {
  color: green;
}

#home {
  .bot-name {
    flex: none;
  }

  .bot {
    border-left: 4px solid;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
}

.bf-disconnected {
  background-color: rgb(252, 255, 198);
}
</style>
